import { message } from "antd";
import { Axios } from "../../utils/axiosMiddleware";
import { SimpleCatchError } from "../../utils/Helper";

/**
 * Resend a contract estimation to the homeowner by email/SMS (G13). Hits the same
 * endpoint the mobile app uses (`auth/sendEmailOrSms/:userName/:contractId`). Shows a
 * success toast on completion and routes failures through the shared error toast.
 * Returns true on success so the caller can react if needed.
 */
export const resendEstimation = async ({ userName, contractId }) => {
  try {
    await Axios.post(
      `auth/sendEmailOrSms/${userName}/${contractId}`,
      { userName, contractId }
    );
    message.success("Estimation resent.");
    return true;
  } catch (e) {
    SimpleCatchError(e);
    return false;
  }
};
